import cx from 'classnames';
import { useState } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import { useWindowSize } from '../../hook/useWindowSize';
import Summary from './summary.component';
import './summary.styles.scss';

const SummaryView = ({
  priceWithDiscount,
  deliveryPrice,
  discount,
  setDiscount,
  setPromoCode,
  setFreeShipping,
  subtotal
}) => {
  const { width } = useWindowSize();
  const [isShowSummary, setIsShowSummary] = useState(true);

  return (
    <aside className="summary">
      <h2 className="summary-title">Résumé de la commande</h2>

      {width <= 900 ? (
        <>
          <button
            type="button"
            onClick={() => setIsShowSummary(!isShowSummary)}
            className="summary-toggle"
          >
            <span>{isShowSummary ? 'Cacher le résumé' : 'Voir le résumé'}</span>

            <BsChevronDown
              className={cx('summary-chevron', { rotate: !isShowSummary })}
              aria-hidden="true"
            />
          </button>
          {isShowSummary && (
            <Summary
              priceWithDiscount={priceWithDiscount}
              discount={discount}
              setDiscount={setDiscount}
              setPromoCode={setPromoCode}
              setFreeShipping={setFreeShipping}
              subtotal={subtotal}
              deliveryPrice={deliveryPrice}
            />
          )}
        </>
      ) : (
        <Summary
          priceWithDiscount={priceWithDiscount}
          discount={discount}
          setDiscount={setDiscount}
          setPromoCode={setPromoCode}
          setFreeShipping={setFreeShipping}
          subtotal={subtotal}
          deliveryPrice={deliveryPrice}
        />
      )}
    </aside>
  );
};

export default SummaryView;
